module.exports = __webpack_public_path__ + "img/the-top-5-challenges-in-implementing-api-strategy.77a89879.jpg";